import React, { useState, useEffect } from 'react';
import { Card, Upload, message, Progress, Button } from 'antd';
import { InboxOutlined } from '@ant-design/icons';
import axios from '../../utils/axiosConfig';
import { qiniuConfig } from '../../config/qiniu.config';
import { qiniuService } from '../../services/qiniu.service';


function Test() {
  const [fileList, setFileList] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [uploadedUrls, setUploadedUrls] = useState([]);

  useEffect(() => {
    const handlePaste = async (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf('image') !== -1) {
          const blob = items[i].getAsFile();
          const file = new File([blob], `pasted-image-${Date.now()}.png`, { type: 'image/png' });
          
          await customRequest({
            file,
            onSuccess: () => {
              message.success(`图片上传成功`);
            },
            onError: (error) => {
              message.error(`图片上传失败: ${error.message}`);
            },
            onProgress: ({ percent }) => {
              setUploadProgress(prev => ({
                ...prev,
                [file.uid]: percent
              }));
            }
          });
        }
      }
    };

    document.addEventListener('paste', handlePaste);
    return () => {
      document.removeEventListener('paste', handlePaste);
    };
  }, []);


  const getUploadToken = async () => {
    try {
      return await qiniuService.getUploadToken();
    } catch (error) {
      message.error('获取上传凭证失败');
      return null;
    }
  };

  const customRequest = async ({ file, onSuccess, onError, onProgress }) => {
    const token = await getUploadToken();
    if (!token) {
      onError(new Error('获取上传凭证失败'));
      return;
    }
    const formData = new FormData();
    formData.append('file', file);
    formData.append('token', token);
    try {
      const response = await axios.post('http://upload.qiniup.com', formData, {
        onUploadProgress: (progressEvent) => {
          const percent = Math.floor((progressEvent.loaded / progressEvent.total) * 100);
          setUploadProgress(prev => ({
            ...prev,
            [file.uid]: percent
          }));
          onProgress({ percent });
        }
      });

      const fileUrl = qiniuConfig.getFullURL(response.data.key); // 使用配置文件中的方法获取完整URL
      setUploadedUrls(prev => [...prev, fileUrl]);
      onSuccess(response.data);
      message.success('上传成功');
    } catch (error) {
      onError(error);
      message.error('上传失败');
    }
  };

  const [selectedFiles, setSelectedFiles] = useState([]);

  const uploadProps = {
    name: 'file',
    multiple: true,
    fileList: selectedFiles,
    customRequest: ({ file, onSuccess }) => {
      // 只将文件添加到选中列表，不立即上传
      onSuccess();
    },
    onChange: ({ fileList: newFileList }) => {
      setSelectedFiles(newFileList);
    },
    onRemove: (file) => {
      setUploadProgress(prev => {
        const newProgress = { ...prev };
        delete newProgress[file.uid];
        return newProgress;
      });
    }
  };

  const handleUpload = async () => {
    if (selectedFiles.length === 0) {
      message.warning('请先选择要上传的文件');
      return;
    }

    for (const file of selectedFiles) {
      await customRequest({
        file: file.originFileObj,
        onSuccess: () => {
          setSelectedFiles(prev => prev.filter(f => f.uid !== file.uid));
          message.success(`文件 ${file.name} 上传成功`);
        },
        onError: (error) => {
          message.error(`文件 ${file.name} 上传失败: ${error.message}`);
        },
        onProgress: ({ percent }) => {
          setUploadProgress(prev => ({
            ...prev,
            [file.uid]: percent
          }));
        }
      });
    }
  };

  return (
    <div>
      <h2>测试页面</h2>
      <div style={{ background: '#fff', padding: '24px', borderRadius: '8px' }}>
        <Card title="七牛云文件上传" bordered={false}>
          <div>
            <Upload.Dragger {...uploadProps}>
              <p className="ant-upload-drag-icon">
                <InboxOutlined />
              </p>
              <p className="ant-upload-text">点击或拖拽文件到此区域选择文件</p>
              <p className="ant-upload-hint">
                支持单个或批量上传，严禁上传公司敏感数据或其他违禁文件
              </p>
            </Upload.Dragger>
            <Button
              type="primary"
              onClick={handleUpload}
              style={{ marginTop: 16, width: '100%' }}
              disabled={selectedFiles.length === 0}
            >
              开始上传
            </Button>
          </div>

          {Object.entries(uploadProgress).map(([uid, progress]) => (
            <div key={uid} style={{ marginTop: 16 }}>
              <Progress percent={progress} />
            </div>
          ))}

          {uploadedUrls.length > 0 && (
            <Card title="已上传文件链接" style={{ marginTop: 16 }}>
              {uploadedUrls.map((url, index) => (
                <div key={index} style={{ marginBottom: 8 }}>
                  <a href={url} target="_blank" rel="noopener noreferrer">{url}</a>
                </div>
              ))}
            </Card>
          )}
        </Card>
      </div>
    </div>
  );
}

export default Test;